'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../input/style');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/pagination/style/index.js
// module id = 74
// module chunks = 0